<template>
  <div>
    <PageName
      :title="`${isEdit ? 'Редактировать' : 'Создать'} внешнего пассажира`"
    />

    <Form :value="passenger" @request="savePassenger" class="create__passenger">
      <div class="create__passenger-form">
        <VInput name="surname" required placeholder="Фамилия" />
        <VSelect
          required
          name="filiation"
          item-text="name"
          placeholder="Филиал"
          :items="filiations"
          searchSelect
          filiation
        />
        <VInput name="name" required placeholder="Имя" />
        <VSelect
          required
          name="department"
          item-text="name"
          placeholder="Подразделение"
          :items="getDepartments"
          searchSelect
          department
        />
        <VInput name="patronymic" placeholder="Отчество" />
        <VInput
          name="phone"
          required
          placeholder="Номер телефона"
        />
        <VInput 
          name="birthday" 
          type="date" 
          placeholder="Дата рождения" 
          required
        />
        <VSelect
          placeholder="Тип документа"
          name="document"
          item-text="name"
          :items="documentTypes"
          v-model="documentType"
        />
        <VInput name="citizenship" required placeholder="Гражданство" />
        <div style="position: relative">
          <VInput
            :required="!!documentType"
            name="document_number"
            placeholder="Номер документа"
            :maskRegex="maskByDocType"
          />
          <!--mask svidetelstvo documentType && documentType.id === 3 ? /[I,V,X]{3}-{1}[А-Я]{2}\s{1}[0-9]{6}$/ : null-->
          <span
            v-tooltip="
              'Номер паспорта РФ должен содержать 10 цифр. <br>' +
              'Номер загранпаспорта РФ должен содержать 9 цифр. <br> '
            "
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM8.13141 7.14286H5.71429C5.71429 4.57143 7.5475 2.85714 10.2857 2.85714C12.8366 2.85714 14.5714 4.49356 14.5714 6.71429C14.5714 8.15632 13.9719 9.20208 12.7143 10C11.528 10.7402 11.0571 11.0671 11.0571 11.99L11.1286 12.8571H8.77143L8.67143 11.9708C8.55548 10.4326 9.19771 9.63584 10.4286 8.85714C11.5792 8.1169 11.8571 7.7512 11.8571 6.85714C11.8571 5.86548 11.1313 5.16439 10 5.16439C8.86867 5.16439 8.18493 6.08537 8.13141 7.14286ZM11.5832 15.7818C11.5832 16.7912 10.9677 17.4161 9.96878 17.4161C8.96982 17.4161 8.34547 16.7912 8.34547 15.7818C8.34547 14.7627 8.96982 14.1379 9.96878 14.1379C10.9677 14.1379 11.5832 14.7627 11.5832 15.7818Z" fill="#B0BBC2"/>
            </svg>
          </span>
        </div>
        <VSelect
          required
          placeholder="Пол"
          name="sex"
          item-text="name"
          :items="sexOption"
        />
        <!-- <VInput required email name="email" placeholder="Электронная почта" /> -->
        <VInput
          :required="!!(documentType && documentType.id === 2)"
          name="document_validity"
          placeholder="Срок действия документа"
          type="date"
          :minDate="new Date()"
        >
          <Validation for="minDate"
            >Документы с вышедшим сроком действия не принимаются</Validation
          >
        </VInput>
        <VSwitch
          v-model="switchValueVip"
          label="VIP"
          @valueChange="switchVip"
          style="margin-top: 12px"
        />

      </div>

      <div>
        <Button
          :loading="saveLoading"
          width="228px"
          height="48px"
          :text="isEdit ? 'Сохранить' : 'Создать'"
          class="btn-primary"
        />
        <Button
          @click.native.prevent="$router.go(-1)"
          width="228px"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          style="margin: 12px 0 32px"
        />

        <Button
          v-if="!isEdit"
          @click.native.prevent="XMLdialog = true"
          width="228px"
          height="48px"
          text="Загрузить с XML"
          class="btn-outline-primary"
        />
      </div>
    </Form>

    <XMLModal
      v-if="XMLdialog"
      @close="XMLdialog = false"
      url="passengers/import"
    />
  </div>
</template>

<script>
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Button from "@/components/Button.vue";
import PageName from "@/components/PageName.vue";
import Validation from "@/components/Form/Validation.vue";
import VSwitch from "@/components/VSwitch.vue";
import XMLModal from "@/components/Modals/XMLModal.vue";
import { createPassenger, updatePassenger } from "@/api/passengers.js";
import { mapActions, mapGetters, mapState } from "vuex";
import { parseDate, simpleDate } from "@/utils/filters/dateFilters";

export default {
  name: "SavePassenger",
  components: {
    PageName,
    Form,
    VInput,
    VSwitch,
    VSelect,
    Button,
    Validation,
    XMLModal
  },
  data() {
    return {
      saveLoading: false,
      passenger: {},
      documentType: null,
      switchValueVip: false,
      XMLdialog: false,
    };
  },
  mounted() {
    if (this.isEdit) {
      const { birthday, document_validity, sex, document } = this.editPassenger;

      this.passenger = {
        ...this.editPassenger,
        document: this.documentTypes.find((doc) => doc.id === document?.id),
        sex: this.sexOption.find((option) => option.value === sex),
        birthday: simpleDate(birthday),
        document_validity: simpleDate(document_validity),
      };

      this.switchValueVip = this.passenger.is_vip
    }

    window.addEventListener("beforeunload", this.prevent);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.prevent);
  },
  computed: {
    ...mapState("options", ["documentTypes", "sexOption"]),
    ...mapGetters("departments", ["getDepartments"]),
    ...mapState("filiations", ["filiations"]),
    editPassenger() {
      return this.$route.params.passenger;
    },
    isEdit() {
      return !!this.editPassenger;
    },
    documentMask() {
      if (this.documentType?.id) {
        switch (this.documentType.id) {
          case 1:
            return "#### ######";
          case 2:
            return "## #######";
          default:
            return "";
        }
      }

      return "";
    },
    maskByDocType() {
      switch (this.documentType?.id) {
        case 1:
          return "#### ######";
        case 2:
          return "## #######";
        // case 3:
        //   return /^[I,V,X]{0,3}-{0,1}[А-Я]{0,2}\s{0,1}[0-9]{0,6}$/;
        default:
          return "";
      }
    },
  },
  methods: {
    ...mapActions("users", ["getPassengers"]),
    prevent(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    async savePassenger(data) {
      const {
        name,
        surname,
        patronymic,
        phone,
        email, // TODO: изменить на login когда бэкенд будет обновлен
        birthday,
        document,
        document_number,
        document_validity,
        sex,
        citizenship,
        department,
        filiation,
        is_vip
      } = data;
      this.saveLoading = true;

      if (!this.isEdit) {
        const is_vip = this.switchValueVip

        await createPassenger(
          name,
          surname,
          patronymic,
          email, // TODO: изменить на login когда бэкенд будет обновлен
          sex?.value,
          birthday ? parseDate(birthday) : null,
          citizenship,
          phone,
          document?.id,
          document_number,
          document_validity ? parseDate(document_validity) : null,
          department.id,
          filiation.id,
          is_vip
        );
      } else {
        await updatePassenger(
          this.editPassenger.id,
          name,
          surname,
          patronymic,
          email, // TODO: изменить на login когда бэкенд будет обновлен
          sex?.value,
          birthday ? parseDate(birthday) : null,
          citizenship,
          document?.id,
          document_number,
          document_validity ? parseDate(document_validity) : null,
          phone,
          department.id,
          filiation.id,
          is_vip
        );
      }

      this.saveLoading = false;
      this.getPassengers();
      this.$router.push({
        name: "Passengers",
        params: { withoutConfrim: true },
      });
    },
    switchVip() {
      this.passenger.is_vip = this.switchValueVip
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.params.withoutConfrim) {
      next();
    } else {
      this.$root.confrim(
        "Вы точно хотите покинуть эту страницу?",
        () => next(),
        "Да"
      );
    }
  },
};
</script>

<style scoped lang="scss">
.create__passenger {
  flex-direction: row;
  gap: 15px;
  margin-top: 32px;

  .create__passenger-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 33px;
    padding: 48px 40px;
    row-gap: 12px;
    background: $light-gray;
    border-radius: 4px;
    width: 100%;
  }
}
</style>
